import React, { Fragment } from "react";
import {
  FilterDropdown,
  ListComponent,
  StatusComponent,
} from "../../../common/component/Index";
import { Icon, Menu, message, Tooltip } from "antd";
import EllipsisText from "../../../common/component/EllipsisText";
import {
  DATE_TIME_FORMAT,
  ERROR_TYPE_POINT_CHANGE_HISTORY,
} from "../../../../../constants/Define";
import moment from "moment";
import { columnsTable, getTitleTable } from "../../../../../helpers/functions";
import PointChangeHistory from "../../../../../models/PointChangeHistory";
import * as Func from "../../../../../helpers/functions";
import Dropdown from "../../../common/component/Dropdown";
import Modal from "../../../common/component/Modal";
import { useTranslation } from "react-i18next";
import * as PointChangeHistoryService from "../../../../../services/pointChangeHistoryService";
import i18n from "../../../../../constants/initLng";

const propTypes = {};

const PointChangeHistoryList = (props) => {
  const {
    loading,
    pointChangeHistory,
    pagination,
    permisions,
    getListPointChangeHistory,
    params,
    onChange,
  } = props;

  //! State
  const ListCols = [
    "creditPoint",
    "createdDate",
    "act",
    "fromAccount",
    "toAccount",
    "createdBy",
    "orderCode",
    "activityCode",
    "updatedDate",
    "updatedBy",
    "status",
  ];

  const { t } = useTranslation();
  const titleItemTable = getTitleTable(ListCols, ["action"], []);
  const modelItem = Object.getOwnPropertyNames(new PointChangeHistory());
  const componentTable = {
    act: {
      width: 200,
      key: "action",
      render: (type, data) => (
        <Fragment>
          {type && (
            <div className="g-mt-5">
              <StatusComponent
                color={t(`item.pointchangehistory.actionColor.${type}`)}
                label={t(`item.pointchangehistory.actionStatus.${type}`)}
              />
            </div>
          )}
        </Fragment>
      ),
      filters: [
        { value: 1, text: `${t(`item.pointchangehistory.actionStatus.1`)}` },
        { value: 2, text: `${t(`item.pointchangehistory.actionStatus.2`)}` },
      ],
    },
    createdDate: {
      render: (text, record) =>
        moment(moment.utc(record.createdDate).toDate()).format(
          DATE_TIME_FORMAT.DATE_TIME
        ),
    },
    fromAccount: {
      key: "fromAccount",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    toAccount: {
      key: "toAccount",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    createdBy: {
      key: "createdBy",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    orderCode: {
      key: "orderCode",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    activityCode: {
      key: "activityCode",
      width: 300,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    updatedDate: {
      render: (text, record) =>
        moment(moment.utc(record.updatedDate).toDate()).format(
          DATE_TIME_FORMAT.DATE_TIME
        ),
    },
    updatedBy: {
      key: "updatedBy",
      width: 200,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        ></FilterDropdown>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#1890ff" : undefined }}
        />
      ),
      render: (text, record) => (
        <EllipsisText
          title={text}
          content={text}
          contentMaxWidth={250}
          overlayClassName={"max-width-500"}
          overlayComponent={Tooltip}
        />
      ),
    },
    status: {
      width: 200,
      key: "status",
      render: (type, data) => (
        <Fragment>
          {type && (
            <div className="g-mt-5">
              <StatusComponent
                color={t(`item.pointchangehistory.statusColor.${type}`)}
                label={t(`item.pointchangehistory.statusList.${type}`)}
              />
            </div>
          )}
        </Fragment>
      ),
      filters: [
        { value: 1, text: `${t(`item.pointchangehistory.statusList.1`)}` },
        { value: 2, text: `${t(`item.pointchangehistory.statusList.2`)}` },
        { value: 3, text: `${t(`item.pointchangehistory.statusList.3`)}` },
        { value: 4, text: `${t(`item.pointchangehistory.statusList.4`)}` },
      ],
    },
    action: {
      fixed: "right",
      width: 100,
      align: "center",
      key: "actionEdit",
      render: (text, record) => renderEditComponent(record),
    },
  };

  const renderEditComponent = (item) => {
    if (item && item?.status !== 1) return <div></div>
    return (
        <Dropdown
          overlay={
            <Menu className="action-menu">
              {permisions && permisions.allowConfirm && (
                <Menu.Item onClick={(e) => onConfirm(item)}>
                  <Icon type="check" className="fs20 mr-1" />
                  {t(`action.confirm`)}
                </Menu.Item>
              )}
              {permisions && permisions.allowCancel && (
                <Menu.Item onClick={(e) => onCancel(item)}>
                  <Icon type="close" className="fs20 mr-1" />
                  {t(`action.cancel`)}
                </Menu.Item>
              )}
            </Menu>
          }
        >
          <Icon type="more" className="fs20 cursorPointer" />
        </Dropdown>
    );
  };

  //! Function

  const onConfirm = (item) => {
    const { confirm } = Modal;
    confirm({
      title: Func.formatValidation(
        t("item.pointchangehistory.statusCode.code.confirm"),
        t(`item.pointchangehistory.title`)
      ),
      okText: t(`action.confirm`),
      cancelText: t(`action.cancel`),
      onOk: () => {
        confirmOK(item);
      },
    });
  };

  const onCancel = (item) => {
    const { confirm } = Modal;
    confirm({
      title: Func.formatValidation(
        t("item.pointchangehistory.statusCode.code.cancel"),
        t(`item.pointchangehistory.title`)
      ),
      okText: t(`action.confirm`),
      cancelText: t(`action.cancel`),
      onOk: () => {
        cancelOk(item);
      },
    });
  };

  const confirmOK = async (item) => {
    try {
      const res = await PointChangeHistoryService.confirmPointChangeHistory({
        activityCode: item.activityCode,
      });
      if (res) {
        message.success(
          t(`item.pointchangehistory.statusCode.code.CONFIRM_SUCCESS`)
        );
      }
    } catch (error) {
      const messageError = error && error?.data?.errors[0]?.code;

      const errCode = ERROR_TYPE_POINT_CHANGE_HISTORY.find(
        (code) => code?.code === messageError
      );

      if (errCode) {
        return message.error(
          i18n.t(`item.pointchangehistory.statusCode.code.${errCode?.code}`)
        );
      }

      return message.error(
        i18n.t(`item.pointchangehistory.statusCode.code.UNDEFINED_ERROR`)
      );
    } finally {
      getListPointChangeHistory(params);
    }
  };

  const cancelOk = async (item) => {
    try {
      const res = await PointChangeHistoryService.cancelPointChangeHistory({
        activityCode: item.activityCode,
      });
      if (res) {
        message.success(
          t(`item.pointchangehistory.statusCode.code.CANCEL_SUCCESS`)
        );
        getListPointChangeHistory(params);
      }
    } catch (error) {
      const messageError = error && error?.data?.errors[0]?.code;
      const errCode = ERROR_TYPE_POINT_CHANGE_HISTORY.find(
        (code) => code?.code === messageError
      );
      if (errCode) {
        return message.error(
          i18n.t(`item.pointchangehistory.statusCode.code.${errCode?.code}`)
        );
      }

      return message.error(
        i18n.t(`item.pointchangehistory.statusCode.code.UNDEFINED_ERROR`)
      );
    } finally {
      getListPointChangeHistory(params);
    }
  };
  //! Render

  return (
    <ListComponent
      tableKey="point-change-history-list"
      scroll={{ x: 3000 }}
      classParent="m-0"
      classChildren="p-0"
      rowKey={(record, k) => (record.id ? record.id : k)}
      loading={{ spinning: loading, size: "large" }}
      dataSource={Func.getDataSource(pointChangeHistory || [], modelItem)}
      columns={columnsTable({
        titleTable: titleItemTable,
        component: componentTable,
        itemName: "pointchangehistory",
      })}
      onChange={onChange}
      pagination={{
        total: pagination.totalCount,
        totalPage: pagination.totalPage,
        defaultPageSize: pagination.pageSize,
        defaultCurrent: pagination.defaultCurrent,
      }}
      componentTableList={{}}
    />
  );
};

PointChangeHistoryList.propTypes = propTypes;
export default PointChangeHistoryList;
